var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustompointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 71,
    viewBox: "0 0 55 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89192 67.4637C6.71766 69.638 3 68.0981 3 65.0232V6.33242C3 3.25755 6.71765 1.71765 8.89192 3.89192L50.9883 45.9883C53.1626 48.1626 51.6227 51.8803 48.5478 51.8803H25.905C24.9897 51.8803 24.1118 52.2439 23.4645 52.8911L8.89192 67.4637Z",
    fill: "white",
    stroke: "#111111",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustompointer);
export default __webpack_public_path__ + "static/media/custompointer.8ee5039547b8b5599d6daa44593f1c07.svg";
export { ForwardRef as ReactComponent };